import { createFeature, createReducer, on } from '@ngrx/store';
import * as authActions from './actions.auth';

export interface AuthState {
  loginResponse: any;
}

const initialAuthState: AuthState = {
  loginResponse: null,
};

export const authReducer = createFeature({
  name: 'authReducer',
  reducer: createReducer(
    initialAuthState,
    on(authActions.updateLocalAuthState, (state, { key, value }) => ({
      ...state,
      [key]: value,
    })),
    on(authActions.basicLoginActions.loginSuccess, (state, { loginResponse }): AuthState => ({ ...state, loginResponse })),
  ),
});
